import {CollectionViewer, DataSource} from "@angular/cdk/collections";
import { UserDto, UserServiceProxy } from "../../../../shared/service-proxies/service-proxies";
import { Observable, BehaviorSubject, of } from "rxjs";
import { catchError, finalize } from 'rxjs/operators';

export class UsersDataSource implements DataSource<UserDto> {

    private userSubject = new BehaviorSubject<UserDto[]>([]);
    private loadinSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this.loadinSubject.asObservable();

    constructor (
        private _userService : UserServiceProxy
    ){

    }

    connect(collectionViewer: CollectionViewer): Observable<UserDto[]> {
        return this.userSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.userSubject.complete();
        this.loadinSubject.complete();
    }

    loadUsers(userId: number, filter:string, sortDirection: string, pageIndex: number, pageSize: number){
        //Loading basliyor...
        this.loadinSubject.next(true);

        this._userService.getAll('', '',false,0 ,0, 100)
        .subscribe(
            users => 
            {this.userSubject.next(users.items)},

            (err) => {}, //Error
            () => {      //OnComplete
                this.loadinSubject.next(false);
            }

            
        )
    }

    
   

}
